import { sendTrack } from '../utilities/track';
import { initSmarty } from '../utilities/smarty';


document.addEventListener('DOMContentLoaded', () => {
  if (!globalThis.unlk?.smartyKey) return;
  const applyBtnSelector = '.qualify-button';
  const applyBtnEl = document.querySelector(applyBtnSelector);
  const utmContent = applyBtnEl?.dataset?.utm?.trim();
  let smartyQualUrl = globalThis.unlk?.smartyQual;

  if (utmContent && smartyQualUrl) {
    const url = new URL(smartyQualUrl, globalThis.location.origin);
    url.searchParams.set('utm_content', utmContent);
    smartyQualUrl = url.toString();
  }

  initSmarty({
    selectors: {
      addressInput: '#autocomplete-address',
      inputGroup: '.hero-smarty .input-group',
      suggestionBox: '#suggestions',
      qualButton: applyBtnSelector,
      invalidScope: '.hero-smarty'
    },
    track: sendTrack,
    smartyKey: globalThis.unlk?.smartyKey,
    activeStates: globalThis.unlk?.activeStates || [],
    smartyQualUrl,
    smartyNonQualUrl: globalThis.unlk?.smartyNonQual
  });
});
